import React from "react";
import { bool, func, string } from "prop-types";

const defaultProps = {
    description: "",
    fullscreen: "",
    isFullscreen: false,
    originalAlt: "",
    originalHeight: "",
    originalWidth: "",
    originalTitle: "",
    sizes: "",
    srcSet: "",
    loading: "eager",
};
const styles = {
    wrapper: {
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        background: "#000"
    },
    bg: {
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "120%",
        height: "120%",
        objectFit: "cover",
        transform: "translate(-50%, -50%)",
        filter: "blur(30px) brightness(0.7)",
        zIndex: 1,
    },
    main: {
        position: "relative",
        zIndex: 2,
    }
};
const Item = React.memo((props) => {


    const {
        description,
        fullscreen, // fullscreen version of img
        handleImageLoaded,
        isFullscreen,
        onImageError,
        original,
        originalAlt,
        originalHeight,
        originalWidth,
        originalTitle,
        sizes,
        srcSet,
        loading,
    } = { ...defaultProps, ...props };
    const itemSrc = isFullscreen ? fullscreen || original : original;

    return (
        <React.Fragment>
            <div style={styles.wrapper} >
                <img src={itemSrc} alt="" style={styles.bg} />
            <img
                className="image-gallery-image"
                src={itemSrc}
                alt={originalAlt}
                srcSet={srcSet}
                height={originalHeight}
                width={originalWidth}
                sizes={sizes}
                title={originalTitle}
                onLoad={(event) => handleImageLoaded(event, original)}
                onError={onImageError}
                loading={loading}
                style={styles.main}
            />
            {description && (
                <span className="image-gallery-description">{description}</span>
            )}

            </div>
        </React.Fragment>
    );
});

Item.displayName = "Item";

Item.propTypes = {
    description: string,
    fullscreen: string, // fullscreen version of img
    handleImageLoaded: func.isRequired,
    isFullscreen: bool,
    onImageError: func.isRequired,
    original: string.isRequired,
    originalAlt: string,
    originalHeight: string,
    originalWidth: string,
    originalTitle: string,
    sizes: string,
    srcSet: string,
    loading: string,
};

export default Item;